/**
 * Montagem de URLs e srcset das fotos de produto.
 *
 * O banco guarda `arquivoBase` SEM sufixo de variante e SEM extensão
 * (ex.: "produtos/clx123/8f14e45f-..."). As variantes são geradas pelo sharp e
 * servidas pelo nginx a partir do volume, em `/uploads/<base>_<sufixo>.webp`.
 */
export const VARIANTES_IMAGEM = [
    { sufixo: 'g', largura: 1600 },
    { sufixo: 'c', largura: 800 },
    { sufixo: 't', largura: 400 },
];
/** "produtos/clx/uuid" + "c" -> "/uploads/produtos/clx/uuid_c.webp" */
export function urlImagem(arquivoBase, sufixo = 'c') {
    return `/uploads/${arquivoBase}_${sufixo}.webp`;
}
/** srcset completo, do menor para o maior, para o browser escolher. */
export function construirSrcSet(arquivoBase) {
    return [...VARIANTES_IMAGEM]
        .sort((a, b) => a.largura - b.largura)
        .map((v) => `${urlImagem(arquivoBase, v.sufixo)} ${v.largura}w`)
        .join(', ');
}
/**
 * Valores de `sizes` por contexto. Precisam acompanhar a grade do Tailwind:
 * novas 1/2/3 colunas com gap-8, usadas 1/2/4 com gap-6, container max-w-7xl.
 */
export const SIZES = {
    cardNova: '(min-width: 1024px) 384px, (min-width: 768px) calc(50vw - 3rem), calc(100vw - 2rem)',
    cardUsada: '(min-width: 1024px) 288px, (min-width: 768px) calc(50vw - 2.5rem), calc(100vw - 2rem)',
    galeria: '(min-width: 1024px) 640px, 100vw',
    miniatura: '96px',
};
/**
 * URL da variante JPEG usada em `og:image`.
 *
 * Fica separada das `VARIANTES_IMAGEM` de propósito: ela NÃO entra em srcset
 * nem na vitrine — é consumida só pelo HTML que a rota `/api/og/produtos/:slug`
 * devolve para crawlers. É JPEG porque o suporte do crawler do WhatsApp a WebP
 * é inconsistente, e a prévia de link é o funil inteiro da loja.
 *
 * Precisa virar ABSOLUTA (`https://dominio` + isto) antes de ir para a meta
 * tag: caminho relativo em og:image quebra a prévia.
 */
export function urlImagemOg(arquivoBase) {
    return `/uploads/${arquivoBase}_og.jpg`;
}
//# sourceMappingURL=imagens.js.map